import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import ProductsPage from "@/pages/products/page";
import ProductDetailPage from "@/pages/product-detail/page";
import DubaiPage from "@/pages/dubai/page";
import SaudiPage from "@/pages/saudi/page";
import QatarPage from "@/pages/qatar/page";
import RegisterSupplierPage from "@/pages/register-supplier/page";
import RegisterFactoryPage from "@/pages/register-factory/page";
import InfluencerPage from "@/pages/influencer/page";
import HowItWorksPage from "@/pages/how-it-works/page";
import FactoryProductDetailPage from "@/pages/factory-product-detail/page";
import SupplierDashboardPage from "@/pages/supplier-dashboard/page";
import GlobalSearchPage from "@/pages/global-search/page";
import RFQPage from "@/pages/rfq/page";
import KuwaitPage from "@/pages/kuwait/page";
import OmanPage from "@/pages/oman/page";
import BahrainPage from "@/pages/bahrain/page";
import TurkeyPage from "@/pages/turkey/page";
import PakistanPage from "@/pages/pakistan/page";
import IsraelPage from "@/pages/israel/page";
import InfantDonationPage from "@/pages/infant-donation/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/products", element: <ProductsPage /> },
  { path: "/products/:id", element: <ProductDetailPage /> },
  { path: "/dubai", element: <DubaiPage /> },
  { path: "/saudi-arabia", element: <SaudiPage /> },
  { path: "/qatar", element: <QatarPage /> },
  { path: "/register-supplier", element: <RegisterSupplierPage /> },
  { path: "/register-factory", element: <RegisterFactoryPage /> },
  { path: "/influencer-program", element: <InfluencerPage /> },
  { path: "/how-it-works", element: <HowItWorksPage /> },
  { path: "/factory-product/:factoryId/:productId", element: <FactoryProductDetailPage /> },
  { path: "/kuwait", element: <KuwaitPage /> },
  { path: "/oman", element: <OmanPage /> },
  { path: "/bahrain", element: <BahrainPage /> },
  { path: "/turkey", element: <TurkeyPage /> },
  { path: "/pakistan", element: <PakistanPage /> },
  { path: "/israel", element: <IsraelPage /> },
  { path: "/infant-donation", element: <InfantDonationPage /> },
  { path: "/supplier-dashboard", element: <SupplierDashboardPage /> },
  { path: "/search", element: <GlobalSearchPage /> },
  { path: "/rfq", element: <RFQPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
